import { ProgressCircle } from "@/components/common/progress-circle";
import { QuizSummaryContent } from "./components/course-chapter-test-summary-content";
import { trans } from "@/service/i18n/i18n";
import { ReactNode } from "react";

function getColor(value: number) {
  if (value <= 33) return "#F43F5E";
  if (value <= 66) return "#FB923C";
  if (value <= 100) return "#0d9488";
}

function getLabel(score: number) {
  if (score <= 33) return "Niestety";
  if (score <= 66) return "Dobrze";
  if (score <= 100) return "Gratulacje";
}

export const CourseChapterTestSummary = ({
  title,
  subtext,
  leftButton,
  rightButton,
  score,
}: {
  title?: string;
  subtext?: string;
  leftButton?: ReactNode;
  rightButton?: ReactNode;
  score: ClientAssessmentScore;
}) => {
  const questionCount = Object.keys(score).length;
  const correctCount = Object.values(score).filter((s) => s.correct).length;
  const incorrectCount = questionCount - correctCount;
  const finalScore = Math.round((correctCount / questionCount) * 100);

  return (
    <div className="@container mx-auto max-w-[var(--content-width)]">
      <header>
        <h1 className={`text-center text-2xl font-semibold text-zinc-900`}>
          {title || trans("exams.exam_completed")}
        </h1>
      </header>

      <div className="my-6 flex items-center justify-center rounded-[10px] border px-4 py-8">
        <div className={"flex max-w-[448px] items-center justify-center gap-8"}>
          <div className={"flex items-center"}>
            {finalScore != null && (
              <ProgressCircle
                percentage={finalScore}
                size={96}
                thickness={6}
                className={"text-lg"}
                color={getColor(finalScore)}
              />
            )}
          </div>
          <div className={"flex flex-col justify-center"}>
            <div className={`text-foreground mb-1 text-lg font-semibold`}>
              {getLabel(finalScore)}!
            </div>
            {subtext && (
              <div className={`text-foreground text-sm font-normal`}>
                {subtext}
              </div>
            )}
          </div>
        </div>
      </div>
      {finalScore != null && (
        <QuizSummaryContent
          correct={correctCount}
          incorrect={incorrectCount}
          questionsCount={questionCount}
        />
      )}
      <div className={"mt-12 flex items-center justify-between"}>
        <div>{leftButton}</div>
        <div>{rightButton}</div>
      </div>
    </div>
  );
};
